import React from 'react';
import { Layout } from '../../components/Layout/Layout';
import Checklists from '../../containers/Checklists/Checklists';
import { useTenantNameSubtitle } from '../../utils/customHooks/useTenantNameSubtitle';

function ChecklistsPage() {
  const tenantNameSubtitle = useTenantNameSubtitle();
  return (
    <Layout
      isMessageLayout
      message={'home_checklists'}
      to="/dashboard"
      showBottomTabs
      subMessageText={tenantNameSubtitle}
      subMessageType="accent"
    >
      <Checklists />
    </Layout>
  );
}

export default ChecklistsPage;
